module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Bold_1.acd05d0b.woff2";